import React, { useState, useEffect, useRef } from "react";
import { getStoreByLatLng } from '../../../service/storeService';
import { getProvince, getDistrict, getWard } from '../../../service/locationService';
import { getLocaltionStore } from "../../../service/cartService";
import Layout from "../../../components/mobile/Layout/layoutmobileempty";
import 'leaflet/dist/leaflet.css';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { pushtracking } from "../../../service/trackingService";
import { useLocation } from "@reach/router";

import './css/termsofuse.css';
const Hethongcuahang =()=> {
    const location = useLocation();
    const locations = [];
    const handleBack = () => {
        window.history.back();
    }
    const containerStyle = {
        width: '100%',
        height: '100vh'
    };

    const [lat, setLat] = useState(0);
    const [long, setLong] = useState(0);
    const [dataItemsStore, setDataItemsStore] = useState([]);
    const [dataItemsStore2, setDataItemsStore2] = useState([]);
    const [ItemsStore, setItemsStore] = useState(null);
    const [selectedStore, setSelectedStore] = useState(null);
    const [zoomLevel, setZoomLevel] = useState(15);
    const [map, setMap] = useState(null);
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyC29UtwcY4jIqdEUYdb5Y9m-xaLwZLosIo"
    });
    //googleMapsApiKey: "AIzaSyC29UtwcY4jIqdEUYdb5Y9m-xaLwZLosIo"
    const getDataStore = (provinceCode, districtCode) => {
        try {
            getStoreByLatLng('', '', provinceCode, districtCode).then((response) => {
                if (+response.status === 200 && response.message !== "Không tìm thấy dữ liệu.") {
                    setDataItemsStore(response.message);
                    setDataItemsStore2(response.message);
                    let lstAddr = response.message;
                    if (lstAddr.length > 0) {
                        lstAddr?.forEach((item) => {
                            let Add = {
                                id: item._id,
                                name: item.name,
                                lat: item.store?.location?.latitude,
                                lng: item.store?.location?.longitude,
                            }
                            locations.push(Add);
                        })
                    }
                }
            });
        } catch (error) {
            console.log(error);
        }
    }
    const getDataStore2 = (provinceCode, districtCode) => {
        try {
            getStoreByLatLng('', '', provinceCode, districtCode).then((response) => {
                if (+response.status === 200 && response.message !== "Không tìm thấy dữ liệu.") {
                    setDataItemsStore2(response.message);
                    let lstAddr = response.message;
                    if (lstAddr.length > 0) {
                        lstAddr?.forEach((item) => {
                            let Add = {
                                id: item._id,
                                name: item.name,
                                lat: item.store?.location?.latitude,
                                lng: item.store?.location?.longitude,
                            }
                            locations.push(Add);
                        })
                    }
                }
            });
        } catch (error) {
            console.log(error);
        }
    }
    const getDataStoreByLatLong = (lat, long) => {
        try {
            getStoreByLatLng(lat, long, '', '').then((response) => {
                if (+response.status === 200 && response.message !== "Không tìm thấy dữ liệu.") {
                    setItemsStore(response.message[0]);
                    setSelectedStore(response.message[0]);
                    setLat(response.message[0]?.store?.location?.latitude);
                    setLong(response.message[0]?.store?.location?.longitude);
                    setTimeout(() => {
                        setZoomLevel(18);
                        map?.panTo({ lat: response.message[0]?.store?.location?.latitude, lng: response.message[0]?.store?.location?.longitude });
                    }, 1000)
                }
            });
        } catch (error) {
            console.log(error);
        }
    }
    const [meta, setMeta] = useState();
    useEffect(() => {
        if (isLoaded) {
            getDataStore('', '');
            listProvince();
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    if (latitude !== null && longitude !== null) {
                        setLat(latitude);
                        setLong(latitude);
                        getDataStoreByLatLong(latitude, longitude);
                        setZoomLevel(15);
                    }
                },
                (error) => {
                    console.error('Error getting current position:', error);
                }
            );
        }
        try{
            pushtracking(window.localStorage.getItem('sessionId')??null,
            window.localStorage.getItem('_id')??null,
            window.localStorage.getItem('phone')??null ,
            location.pathname, "Hệ thống cửa hàng", 0,0,'index','inWeb',[],'Website Mobile').then((response)=>{
                console.log('send tracking');
            });
        }catch(e){console.log(e)}
        
    }, [isLoaded]);

    const pickStore = (store) => {
        try {
            setLat(store.store?.location?.latitude);
            setLong(store.store?.location?.longitude);
            setSelectedStore(store);
            if (map && store.store?.location?.latitude && store.store?.location?.longitude) {
                setZoomLevel(18);
                map.panTo({ lat: store.store?.location?.latitude, lng: store.store?.location?.longitude });
            }
        } catch (e) { }

    }
    const pickStore2 = (store) => {
        setIsShowList(false);
        setLat(store.store?.location?.latitude);
        setLong(store.store?.location?.longitude);
        setSelectedStore(store);
        setTimeout(() => {
            try {
                if (map && store.store?.location?.latitude && store.store?.location?.longitude) {
                    map.panTo({ lat: store.store?.location?.latitude, lng: store.store?.location?.longitude });
                    setZoomLevel(18);
                }
            } catch (e) { }
        }, 1000);
    }
    const onLoad = React.useCallback(
        (mapInstance) => {

            const bounds = new window.google.maps.LatLngBounds();
            dataItemsStore.forEach((location) => {
                if (location.store?.location?.latitude > 0 && location.store?.location?.longitude > 0) {
                    bounds.extend(
                        new window.google.maps.LatLng(
                            location.store?.location?.latitude,
                            location.store?.location?.longitude
                        )
                    );
                }
            });
            mapRef.current = mapInstance;
            mapInstance.fitBounds(bounds);
            setMap(mapInstance);
        },
        [dataItemsStore]
    );
    const [tab, setTab] = useState('map');
    const mapRef = useRef();
    const [province, setProvince] = useState([]);
    const [itemProvinces, setItemProvince] = useState([]);
    const [itemDistrict, setItemDistrict] = useState([]);
    const handleShowDisstrict = (e) => {
        e.preventDefault();
        let value = e.target.value;
        var index = e.target.selectedIndex;
        var optionElement = e.target.childNodes[index]
        var option = optionElement.getAttribute('data');
        if (option !== null) {
            const { region, ...rest } = JSON.parse(option);
            setProvince(rest);
            getDataStore2(rest.code, '');
            listDistrict(value);
        }
        // console.log(rest);
    }
    const listProvince = () => {
        try {
            if (itemProvinces.length < 1) {
                getProvince().then((response) => {
                    setItemProvince(response['message']);
                })
            }
        } catch (e) {
            console.log(e);
        }
    };
    const [district, setDistrict] = useState([]);
    const listDistrict = (id) => {
        try {
            getDistrict(id).then((response) => {
                setItemDistrict(response['message']);
            })
        } catch (e) {
            console.log(e);
        }
    };
    const handleShowWard = (e) => {
        e.preventDefault();
        let value = e.target.value;
        var index = e.target.selectedIndex;
        var optionElement = e.target.childNodes[index]
        var option = optionElement.getAttribute('data');
        if (option !== null) {
            setDistrict(JSON.parse(option));
            getDataStore2(province.code, JSON.parse(option).code);
            listWard(value);
        }

    }
    const [itemWard, setItemWard] = useState([]);
    const listWard = (id) => {
        try {
            getWard(id).then((response) => {
                setItemWard(response['message']);
            })
        } catch (e) {
            console.log(e);
        }
    };
    const handleGetstore = (e) => {
        e.preventDefault();
        var option = '';
        var index = e.target.selectedIndex;
        var optionElement = e.target.childNodes[index]
        option = optionElement.getAttribute('data');
        try {
            if (option !== '') {
                getLocaltionStore(option, window.localStorage.getItem('key')).then((response) => {
                    if (response.status === 200 && response.message !== "Không tìm thấy dữ liệu.") {
                        setDataItemsStore2(response['message']);
                    }
                });
            }

        } catch (e) { console.log(e); }
    };
    const [isShowList, setIsShowList] = useState(false);
    const defaultMapOptions = {
        fullscreenControl: false,
        disableDefaultUI: true,
        draggable: false
      };
    if (isLoaded) {
        return (
            <>
                <Layout>
                {/* <h1 className='d-none'>Hệ thống cửa hàng</h1> */}
                    {!isShowList ?
                        (
                            <>
                                <div className="fixed bg-index">
                                    <div className="row bg-white ">
                                        <div className="row header d-flex pdx-10 pdy-10">
                                            <div className="col-3 mgl-10" onClick={() => handleBack()}>
                                                <i className="fa-solid fa fa-chevron-left"></i>
                                            </div>
                                            <div className="col-6 text-center">
                                                <span className="text-normal-16">Danh sách cửa hàng</span>
                                            </div>
                                            <div className="col-3"></div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="fixed bg-index">
                                    <div className="row bg-white ">
                                        <div className="row header d-flex pdx-10 pdy-10">
                                            <div className="col-3 mgl-10" onClick={() => setIsShowList(false)}>
                                                <i className="fa-solid fa fa-chevron-left"></i>
                                            </div>
                                            <div className="col-6 text-center">
                                                <span className="name-page">Tìm cửa hàng</span>
                                            </div>
                                            <div className="col-3">
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row mgt-10">
                                        <div>
                                            <div className="mgx-10">
                                                <select className="select-custom w-100" name="province" required onChange={(e) => handleShowDisstrict(e)}>
                                                    <option value="">Chọn Tỉnh/Thành phố</option>
                                                    {
                                                        itemProvinces?.map((item, i) => {
                                                            return <option key={i} value={item._id} data={JSON.stringify(item)}>{item.name}</option>
                                                        })
                                                    }
                                                </select>
                                                <div className="col-md-12 mgt-5 m-body">
                                                    <div className="address-location">
                                                        <div className="m-location-detail">
                                                            <div className="col-md-12 c1 m1">
                                                                <select className="select-custom w-100" required onChange={(e) => handleShowWard(e)} name="district">
                                                                    <option value="">Chọn Quận, Huyện</option>
                                                                    {
                                                                        itemDistrict?.map((item, i) => {
                                                                            return <option key={i} value={item._id} data={JSON.stringify(item)}>{item.name}</option>
                                                                        })
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="m-location-detail">
                                                            <div className="col-md-12 m1">
                                                                <select className="select-custom w-100" required name="ward" onChange={(e) => handleGetstore(e)}>
                                                                    <option value="">Chọn Phường, Xã</option>
                                                                    {
                                                                        itemWard?.map((item, i) => {
                                                                            return <option key={i} value={item._id} data={item.code}>{item.name}</option>
                                                                        })
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                    }
                    {isLoaded && (
                        <GoogleMap
                            mapContainerStyle={containerStyle}
                            center={{ lat: lat, lng: long }}
                            zoom={zoomLevel}
                            onLoad={onLoad}
                            ref={mapRef}
                            options={defaultMapOptions}
                        >
                            {dataItemsStore.map((location) => (
                                location.store?.location?.latitude > 0 && location.store?.location?.longitude > 0 && (
                                    <Marker
                                        key={location.store._id}
                                        position={{ lat: location.store?.location?.latitude, lng: location.store?.location?.longitude }}
                                        onClick={() => pickStore(location)}
                                    />
                                )
                            ))}
                            {selectedStore && (
                                <div className="mgt-10 address-map-detail" onClick={() => { pickStore(selectedStore) }}>
                                    <div className="group-btn-list-store" onClick={() => setIsShowList(true)}>
                                        <button className="btn-list-store bg-white text-normal-12"><i className="fas fa-bars text-normal-12"></i> Danh sách</button>
                                    </div>
                                    <div className="bg-white mgt-10 pdy-12 pdx-10 address-map-detail-body">
                                        <div className="d-flex justify-content-between">
                                            <span className="text-bold-13 text-red">{selectedStore.store?.name}</span>
                                        </div>
                                        <div className="d-flex">
                                            <div>
                                                <span className="text-normal-13">
                                                    {selectedStore.store?.address}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between mgt-5">
                                            <div>
                                                <span className="text-normal-12">
                                                    <a href="#">024 7309 1168</a> - Số máy lẻ: {selectedStore.store?.code}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="d-flex">
                                            <div>
                                                <span className="text-normal-12">
                                                    Mở cửa: {selectedStore.store?.working?.open}:00 - {selectedStore.store?.working?.close}:00
                                                </span>
                                            </div>
                                        </div>
                                        <div className="d-flex">
                                            <div className="link-map">
                                            <i class="fa fa-location-arrow"></i>
                                                <span className="add-detail-fz-12">
                                                    <a href={'https://www.google.com/maps/dir//'+selectedStore.store?.location?.latitude+','+selectedStore.store?.location?.longitude} target='_blank'> Chỉ đường</a>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                // </InfoWindow>
                            )}
                        </GoogleMap>
                    )}
                    {isShowList ?
                        (
                            <>
                                <div id="list-store-map">

                                    <div style={{ height: 128 }}></div>
                                    <div className="row">
                                        <div>
                                            <div className="bg-white text-center pdy-10">
                                                <span className="text-bold-14">Có {dataItemsStore2.length} cửa hàng</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="list-store-scroll">
                                        {

                                            dataItemsStore2.length > 0 ? (
                                                dataItemsStore2.map((item, i) => {
                                                    return <>
                                                        <div className="row pdx-20 mgx-0" onClick={() => pickStore2(item)}>
                                                            <div className="mgt-10 pdx-0">
                                                                <div className="bg-white pdy-12 pdx-15">
                                                                    <div className="d-flex justify-content-between">
                                                                        <span className="text-bold-13 fw-bold">{item.store?.name}</span>
                                                                    </div>
                                                                    <div className="d-flex mgt-5">
                                                                        <div className="d-flex align-items-center mgr-10">
                                                                            <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/location.png" alt="icon" />
                                                                        </div>
                                                                        <div className="d-flex">
                                                                            <span className="text-normal-13 line-hei-15">
                                                                                {item.store?.address}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex mgt-5">
                                                                        <div className="d-flex align-items-center mgr-10">
                                                                            <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/clock.png" alt="icon" />
                                                                        </div>
                                                                        <div>
                                                                            <span className="text-normal-13">
                                                                                {item.store?.working?.open}:00 - {item.store?.working?.close}:00
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex justify-content-between mgt-5">
                                                                        <div>
                                                                            <img className="mgr-10" src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/call.png" alt="icon" />
                                                                            <span className="text-13-red">024 7309 1168</span>
                                                                        </div>
                                                                        {/* <div>
                                                                                <i className="fa fa-person-walking text-danger mgr-5"></i>
                                                                                <span className="text-13-red">  {Rounding(item.distance ?? 0, 1)} km</span>
                                                                            </div> */}
                                                                        <div className="link-google">
                                                                            <a href={'https://www.google.com/maps/dir/?api=1&destination=' + item.store?.location?.latitude + ',' + item.store?.location?.longitude + '&travelmode=driving'} target="_blank">
                                                                                <img className="mgr-10" src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/people.png" alt="icon" />
                                                                                <span className="text-13-red">Chỉ đường</span>
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                })
                                            ) : (null)
                                        }
                                    </div>

                                </div>
                            </>
                        ) : (null)
                    }
                </Layout>

            </>

        );
    } else { return null; }

};
export default Hethongcuahang;
